<!--预存变动明细-->
<template>
  <div>
    <a-spin :spinning="loading">
      <a-form ref="form" :model="formState" name="form" @finish="onSearch">
        <a-row>
          <a-form-item class="ui-form__item" name="organizationId" label="影院组织" v-if="fundMode == 2">
            <a-select placeholder="请选择影院组织" v-model:value="formState.organizationId" style="width: 250px;"
                      @change="getAllCinemaList">
              <a-select-option v-for="item in organizationList" :vlaue="item.id" :key="item.id">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item class="ui-form__item" name="cinemaId" label="所属影院" v-if="fundMode == 2">
            <a-select placeholder="请选择所属影院" v-model:value="formState.cinemaId" style="width: 250px;">
              <a-select-option :value="999">全部</a-select-option>
              <a-select-option :value="0">项目</a-select-option>
              <a-select-option v-for="item in cinemaAllList" :vlaue="item.id" :key="item.id">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="变动时间" class="ui-form__item">
            <a-range-picker v-model:value="time"></a-range-picker>
          </a-form-item>

          <a-form-item class="ui-form__item" name="type" label="变动类型">
            <a-select placeholder="请选择" v-model:value="formState.type" style="width: 250px;">
              <a-select-option :value="1">消耗</a-select-option>
              <a-select-option :value="2">预存</a-select-option>
            </a-select>
          </a-form-item>

        </a-row>

        <a-row>
          <a-col :span="18">
            <span>
              <ExportReport v-permission="['fundCenter_balance_info_export']" type="preStoreDayRecord" :searchData="searchData"></ExportReport>
            </span>
            <a-button @click="onRefreshToday" style="margin-left: 20px">刷新今日数据</a-button>
          </a-col>
          <a-col :span="6" style="text-align: right;">
            <a-button style="margin-right: 10px" type="primary" html-type="submit">搜索</a-button>
            <a-button @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form>

      <div style="margin-top: 20px;">
        <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="list">
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'cinemaName'">
              <p v-if="record.cinemaName">{{ record.cinemaName }}</p>
              <p v-else>项目</p>
            </template>
            <template v-if="column.dataIndex === 'cinemaCode'">
              <p v-if="record.cinemaCode">{{ record.cinemaCode }}</p>
              <p v-else>-</p>
            </template>
            <template v-if="column.dataIndex === 'type'">
              {{ record.type == 1 ? '消耗' : '预存' }}
            </template>
            <template v-if="column.dataIndex === 'statementTime'">
              <template v-if="record.statementTime">{{ transDateTime(record.statementTime, 1) }}</template>
              <template v-else>-</template>
            </template>

          </template>
        </a-table>
      </div>
    </a-spin>
    <Mode :showConfigMode="showConfigMode" @onRefreshMode="getSettingDetail" @onRefresh="onSearch" @close="onClosePage"></Mode>
  </div>
</template>

<script>
  import {
    Icon
  } from '@/components/icon/icon.js';
  import {
    getOrganizationList,
    getCinemaList,
  } from '@/service/modules/cinema.js';

  import {
    getPreStoreStatistics, getSettingDetail, savePreStoreStatistics
  } from "@/service/modules/preStoreCenter.js";

  import ExportReport from '@/components/exportReport/exportReport.vue';
  import Mode from '../components/mode.vue';
  export default {
    components: {
      Icon,
      ExportReport,
      Mode
    },
    data() {
      return {
        loading: false,
        showAll: false,
        organizationList: [],
        cinemaAllList: [],
        time: [],
        formState: {
          organizationId: 0,
        },
        searchData: {},
        list: [],
        showConfigMode: false,
        fundMode: 0,
        columns: [{
          title: '所属影院',
          dataIndex: 'cinemaName'
        }, {
          title: '影院八位编码',
          dataIndex: 'cinemaCode',
        }, {
          title: '变动类型',
          dataIndex: 'type',
        }, {
          title: '变动金额',
          dataIndex: 'changeAmount'
        }, {
          title: '时间',
          dataIndex: 'statementTime'
        }],
        pagination: {
          showSizeChanger: true,
          showQuickJumper: true,
          size: "middle",
          showTotal: (total) => {
            return "共 " + total + " 条";
          },
          total: 0,
          current: 1,
          pageSize: 10,
          onChange: (page) => {
            this.pagination.current = page;
            this.getAllCinemaList();
          },
          onShowSizeChange: (page, pageSize) => {
            this.pagination.current = 1;
            this.pagination.pageSize = pageSize;
            this.getAllCinemaList();
          }
        },
      }
    },
    created() {
      this.getSettingDetail();
      this.getOrganizationList();
      this.onSearch();
    },
    methods: {
      onSearch() {
        this.pagination.current = 1;
        // this.pagination.pageSize = 10;
        this.searchData = JSON.parse(JSON.stringify(this.formState));
        this.searchData.organizationId = (this.fundMode == 2 && this.searchData.organizationId) ? this.searchData.organizationId : undefined;
        this.searchData.cinemaId = this.searchData.cinemaId !== 999 ? this.searchData.cinemaId : undefined;
        this.searchData.type = this.searchData.type ? this.searchData.type : undefined;
        if (this.time && this.time.length) {
          this.searchData.startTime = this.time[0].startOf('day').unix();
          this.searchData.endTime = this.time[1].endOf('day').unix();
        }
        console.log(JSON.stringify(this.searchData))
        // this.getAllCinemaList();
        this.getPreStoreStatistics();
      },
      reset() {
        this.time = [];
        this.$refs.form.resetFields();
        this.onSearch();
      },
      async getOrganizationList() {
        let ret = await getOrganizationList({
          page: 1,
          pageSize: 999999
        });
        if (ret.code === 200) {
          this.organizationList = ret.data.list;
          if (this.organizationList.length) {
            this.formState.organizationId = this.organizationList[0].id;
            this.getAllCinemaList(this.formState.organizationId);
          }
        }
      },
      async getAllCinemaList(organizationId) {
        this.cinemaAllList = [];
        this.formState.cinemaId = 999;
        let ret = await getCinemaList({
          page: 1,
          pageSize: 999999,
          organizationId: organizationId ? organizationId : undefined,
          ...this.searchData
        })
        if (ret.code === 200) {
          this.cinemaAllList = ret.data.list;
        }
      },
      async getPreStoreStatistics() {
        const postData = {
          ...this.searchData,
        };
        const ret = await getPreStoreStatistics(postData);
        if (ret.code == 200) {
          this.list = ret.data.list;
        }
      },
      onClosePage() {
        this.showConfigMode = false;
        this.$closePage(this.$router.currentRoute.value, '/index');
      },
      async getSettingDetail() {
        const ret = await getSettingDetail();
        if (ret.code == 200) {
          if (!Object.keys(ret.data).length || ret.data == 0) {
            this.showConfigMode = true;
            return
          }
          this.fundMode = ret.data;
          this.showConfigMode = false;
        }
      },
      async onRefreshToday() {
        const {code, data} = await savePreStoreStatistics({});
        if (code == 200) {
          this.$message.success('刷新成功');
        }
      }
    }
  }
</script>

<style scoped>
    .ui-form__item {
        margin-right: 30px;
    }
</style>
